import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

/** Official store badges (Google's artwork, unaltered; the PNG carries its own clear-space padding, so 64px tall shows a ~43px badge, above Google's minimum; the -10px margin lines that visible edge up with left-aligned text). Add the App Store badge here once iOS is live. Prerender-safe: used by the marketing hero and `FooterParts`. */
const STORES = [
  {href: 'https://play.google.com/store/apps/details?id=com.gnothiai.app', src: '/badges/google-play.png', alt: 'Get it on Google Play', width: 165},
] as const

export default function StoreBadges() {
  return <Stack direction="row" spacing={1} sx={{alignItems: 'center', ml: '-10px'}}>
    {STORES.map(s => <Box key={s.href} component="a" href={s.href} target="_blank" rel="noopener" sx={{display: 'inline-flex', lineHeight: 0}}>
      <Box component="img" src={s.src} alt={s.alt} width={s.width} height={64} sx={{display: 'block'}}/>
    </Box>)}
  </Stack>
}
